// @ts-nocheck
export const MODEL_NAME = 'orderExplainer';

